export default __webpack_public_path__ + "static/media/invoice-color-icon.58d651bf.svg";